<header class="header--page hide--modal" *ngIf="showHeader">
    <ul class="header__nav">
        <li>
            <h1>Add New Customer</h1>
        </li>
    </ul>
</header>
<form class="mvd_container" [formGroup]="form" autocomplete="off">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="well mvd_container--pdf">
        <div class="row">
            <div class="col-sm-2 col-md-1">
                <h2>Customer</h2>
            </div>
            <div class="col-sm-3 col-sm-2 h2__input" *ngIf="showCustomerType">
                <select class="mvd_form-control" data-id="customerTypeId" formControlName="customerTypeId">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let typ of customerTypeList" [ngValue]="typ.id">{{ typ.displayValue }}</option>
                </select>
            </div>
        </div>
        <ng-container *ngIf="showIndividual">
            <h2>Customer</h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>Legal First Name</label>
                        <input type="text" class="mvd_form-control" data-id="firstName" formControlName="firstName" trim="blur" />
                        <control-validation-messages control="firstName"></control-validation-messages>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>Legal Middle Name</label>
                        <input type="text" class="mvd_form-control" data-id="middleName" formControlName="middleName" trim="blur" />
                        <control-validation-messages control="middleName"></control-validation-messages>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label class="required" title="* Required">Legal Last Name</label>
                        <input type="text" class="mvd_form-control" data-id="lastName" formControlName="lastName" trim="blur"/>
                        <control-validation-messages control="lastName"></control-validation-messages>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>Suffix</label>
                        <select class="mvd_form-control" data-id="NameSuffix" formControlName="customerIndividualNameSuffixTypeId">
                            <option [ngValue]="null"></option>
                            <option *ngFor="let suffix of suffixTypes" [ngValue]="suffix.id">{{ suffix.displayValue }}</option>
                        </select>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>Date of Birth</label>
                        <p-calendar [showIcon]="true" formControlName="dateOfBirth"></p-calendar>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>SSN</label>
                        <ng-container *ngIf="maskSSN">
                            <p-inputMask *ngIf="!form.value.SSN || form.value.SSN.length !== 9" 
                                class="mvd_control-label"
                                mask="999-99-9999"
                                placeholder="xxx-xx-xxxx"
                                formControlName="SSN"
                                styleClass="data-id_ssn"
                                unmask="true">
                            </p-inputMask>
                            <input *ngIf="form.value.SSN && form.value.SSN.length === 9" 
                                class="mvd_form-control data-id_ssn" type="text" [attr.disabled]="true" [value]="'***-**-' + form.value.SSN.substring(5,9)"/>
                        </ng-container>
                        <p-inputMask *ngIf="!maskSSN"
                            class="mvd_control-label"
                            mask="999-99-9999"
                            placeholder="xxx-xx-xxxx"
                            formControlName="SSN"
                            styleClass="data-id_ssn"
                            unmask="true">
                        </p-inputMask>
                    </div>
                </div>
                <div class="mvd_form-group" *ngIf="address?.addressLine1 == '' || address?.addressLine1 == undefined">
                    <a class="icon--add" href="javascript:void(0)" (click)="selectIndividualAddress()"> Add an Address</a>
                </div>
            </fieldset>

            <ng-container *ngIf="address?.addressLine1 != '' && address?.addressLine1 != undefined">
                <h2>Customer Addresses</h2>
                <table class="mvd_table--primeng">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Address</th>
                            <th>Ste,Apt,Etc.</th>
                            <th>City</th>
                            <th>State</th>
                            <th>ZIP Code</th>
                            <th>County</th>
                            <th>Country</th>
                            <th class="w--icon">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ address?.addressType }}</td>
                            <td>{{ address?.addressLine1 }}</td>
                            <td>{{ address?.addressLine2 }}</td>
                            <td>{{ address?.city }}</td>
                            <td>{{ address?.state }}</td>
                            <td>{{ address?.postalZipCode | zipCode }}</td>
                            <td>{{ address?.county }}</td>
                            <td>{{ address?.country }}</td>
                            <td class="text-center">
                                <a class="icon--delete" title="Delete Address" href="javascript:void(0)" (click)="deleteAddress()"></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <h2>Contact Methods</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Contact Type</th>
                        <th>Contact Info</th>
                        <th>Text/Email Enabled</th>
                        <th>Primary</th>
                        <th>Preferred Contact Method</th>
                    </tr>
                </thead>
                <tbody>
                    <tr formGroupName="email">
                        <td>Personal Email</td>
                        <td>
                            <input type="text" class="mvd_form-control" formControlName="customerContactValue" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isCorrespondenceEnabled" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isPrimary" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isPreferredContactMethod" />
                        </td>
                    </tr>
                    <tr formGroupName="cellPhone">
                        <td>Personal Cell</td>
                        <td>
                            <p-inputMask styleClass="mvd_form-control" mask="(999) 999-9999" formControlName="customerContactValue"></p-inputMask>
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isCorrespondenceEnabled" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isPrimary" />
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div class="well__footer">
                <div class="btn--group">
                    <button type="button" class="btn--default" (click)="cancel()">Cancel</button>
                    <mvm-spinner-btn dataId="save1" [isDisabled]="form.invalid" [isLoading]="showButtonLoading" btnText="Save" (clicked)="saveIndividualCustomer()"></mvm-spinner-btn>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!showIndividual">
            <h2>Organization</h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label class="required" title="* Required">Organization Name</label>
                        <input type="text" class="mvd_form-control" formControlName="organizationName" trim="blur"/>
                        <control-validation-messages control="organizationName"></control-validation-messages>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group">
                        <label>Organization Type</label>
                        <select class="mvd_form-control" formControlName="organizationTypeId">
                            <option [ngValue]="null"></option>
                            <option *ngFor="let organizationType of organizationTypeList" [ngValue]="organizationType.id">{{ organizationType.displayValue }}</option>
                        </select>
                        <control-validation-messages control="organizationTypeId"></control-validation-messages>
                    </div>
                    <div class="col-sm-4 col-md-2 mvd_form-group" *ngIf="showEIN">
                        <label>EIN</label>
                        <p-inputMask class="mvd_control-label"
                                     mask="99-9999999"
                                     placeholder="xx-xxxxxxx"
                                     formControlName="EIN"
                                     styleClass="data-id_ein"
                                     unmask="true">
                        </p-inputMask>
                    </div>
                    <div class="col-sm-4 col-md-3 mvd_form-group" *ngIf="!showEIN">
                        <label>OIN</label>
                        <input type="text" class="mvd_form-control" formControlName="OIN" [attr.disabled]="true" />
                    </div>
                    <div class="col-sm-4 col-md-3 mvd_form-group">
                        <button class="icon--renew btn--default" type="button" (click)="attestation()" *ngIf="showEIN">Generate OIN</button>
                    </div>
                </div>
                <div class="mvd_form-group" *ngIf="address?.addressLine1 == '' || address?.addressLine1 == undefined">
                    <a class="icon--add" href="javascript:void(0)" (click)="selectOrganizationAddress()"> Add New Address</a>
                </div>
            </fieldset>

            <ng-container *ngIf="address?.addressLine1 != '' && address?.addressLine1 != undefined">
                <h2>Organization Address</h2>
                <table class="mvd_table--primeng">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Address</th>
                            <th>Ste,Apt,Etc.</th>
                            <th>City</th>
                            <th>State</th>
                            <th>ZIP Code</th>
                            <th>County</th>
                            <th>Country</th>
                            <th class="w--icon">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ address?.addressType }}</td>
                            <td>{{ address?.addressLine1 }}</td>
                            <td>{{ address?.addressLine2 }}</td>
                            <td>{{ address?.city }}</td>
                            <td>{{ address?.state }}</td>
                            <td>{{ address?.postalZipCode | zipCode }}</td>
                            <td>{{ address?.county }}</td>
                            <td>{{ address?.country }}</td>
                            <td class="text-center">
                                <a class="icon--delete" title="Delete Address" href="javascript:void(0)" (click)="deleteAddress()"></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <h2>Organization Contact Methods</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Contact Type</th>
                        <th>Contact Info</th>
                        <th>Text/Email Enabled</th>
                        <th>Primary</th>
                        <th>Preferred Contact Method</th>
                    </tr>
                </thead>
                <tbody>
                    <tr formGroupName="email">
                        <td>Business Email</td>
                        <td>
                            <input type="text" class="mvd_form-control" formControlName="customerContactValue" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isCorrespondenceEnabled" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isPrimary" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isPreferredContactMethod" />
                        </td>
                    </tr>
                    <tr formGroupName="cellPhone">
                        <td>Business Cell</td>
                        <td>
                            <p-inputMask styleClass="businessCell_customerContactValue" mask="(999) 999-9999" formControlName="customerContactValue"></p-inputMask>
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isCorrespondenceEnabled" />
                        </td>
                        <td>
                            <input type="checkbox" formControlName="isPrimary" />
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div class="well__footer">
                <div class="btn--group">
                    <button type="button" class="btn--default" (click)="cancel()">Cancel</button>
                    <mvm-spinner-btn dataId="save2" [isDisabled]="!form.valid" [isLoading]="showButtonLoading" btnText="Save" (clicked)="saveOrganizationCustomer()"></mvm-spinner-btn>
                </div>
            </div>
        </ng-container>
    </div>
</form>